import { Component, Emit, Prop, PropSync, Provide, Vue } from 'vue-property-decorator'
import { TranslationResponse } from '@/api/services/common.dto'
import VtFlags from '@/components/common/VtFlags.vue'
import { NotificationType } from '@/modules/configurationModule/detail/notifications/models/notification-types'

@Component({
    components: { VtFlags }
})
export default class TextTranslations extends Vue {
    @Provide() externalValidator = this.$validator
    @PropSync('translations') syncedTranslations!: TranslationResponse[]
    @Prop() notificationType!: NotificationType
    @Prop({ default: false }) richTextEditor!: boolean
    @Emit()
    update(): boolean {
        return true
    }

    onAllowedVariablesBadgeClick(allowedVariable: string, translation: TranslationResponse): void {
        translation.value += `{{${allowedVariable}}}`
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }

    get modelValidated(): boolean {
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors
    }

    actionModal(): void {
        this.update()
    }
}
